import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WorkOrderSharedService {
  private equipmentImagesLength$ = new BehaviorSubject<number | null>(null);
  private equipmentImagesAddObject = new BehaviorSubject<boolean | null>(null);
  public equipmentImagesAddObject$: Observable<boolean | null> = this.equipmentImagesAddObject.asObservable();
  private equipmentVideosLength$ = new BehaviorSubject<number | null>(null);
  private equipmentVideosAddObject = new BehaviorSubject<boolean | null>(null);
  public equipmentVideosAddObject$: Observable<boolean | null> = this.equipmentVideosAddObject.asObservable();
  private equipmentDocumentLength$ = new BehaviorSubject<number | null>(null);
  private equipmentDocumentAddObject = new BehaviorSubject<boolean | null>(null);
  public equipmentDocumentsAddObject$: Observable<boolean | null> = this.equipmentDocumentAddObject.asObservable();
  private billToSetState$ = new BehaviorSubject<number | null>(null);
  private shipToSetState$ = new BehaviorSubject<number | null>(null);
  private equipmentDepartment$ = new BehaviorSubject<object | null>(null);
  private checkSheetLocation$ = new BehaviorSubject<number | null>(null);
  private submitFunctionHit = new BehaviorSubject<boolean | null>(null);
  public submitFunctionHit$: Observable<boolean | null> = this.submitFunctionHit.asObservable();
  public refresh$ = new Subject<boolean>();
  public refreshSideBar$ = new Subject<boolean>();
  private workOrderEditMode = new BehaviorSubject<boolean | null>(null);
  public workOrderEditMode$: Observable<boolean | null> = this.workOrderEditMode.asObservable();
  private shipToShipment = new BehaviorSubject<object | null>(null);
  public shipToShipment$: Observable<object | null> = this.shipToShipment.asObservable();
  private loadContracts = new BehaviorSubject<object | null>(null);
  public loadContracts$: Observable<object | null> = this.loadContracts.asObservable()
  private loadpricingInfo = new BehaviorSubject<object | null>(null);
  public loadpricingInfo$: Observable<object | null> = this.loadpricingInfo.asObservable()
  private disabledRemoveButtons = new BehaviorSubject<boolean>(false);
  public disabledRemoveButtons$: Observable<boolean> = this.disabledRemoveButtons.asObservable()

  constructor() { }

  public setEquipmentImagesLength = (length: number): void => {
    this.equipmentImagesLength$.next(length);
  }
  public getEquipmentImagesLength = (): Observable<number | null> => {
    return this.equipmentImagesLength$.asObservable();
  }
  public setEquipmentImagesAddObject = (add: boolean): void => {
    this.equipmentImagesAddObject.next(add);
  }
  public setEquipmentVideosLength = (length: number): void => {
    this.equipmentVideosLength$.next(length);
  }
  public getEquipmentVideosLength = (): Observable<number | null> => {
    return this.equipmentVideosLength$.asObservable();
  }
  public setEquipmentVideosAddObject = (add: boolean): void => {
    this.equipmentVideosAddObject.next(add);
  }
  public setEquipmentDocumentsLength = (length: number): void => {
    this.equipmentDocumentLength$.next(length);
  }
  public getEquipmentDocumentsLength = (): Observable<number | null> => {
    return this.equipmentDocumentLength$.asObservable();
  }
  public setEquipmentDocumentsAddObject = (add: boolean): void => {
    this.equipmentDocumentAddObject.next(add);
  }
  public clearObjects = (): void => {
    this.equipmentImagesAddObject.next(null);
    this.equipmentVideosAddObject.next(null);
    this.equipmentDocumentAddObject.next(null);
    this.submitFunctionHit.next(null);
  }
  public setBillToSetState = (id: number | null): void => {
    this.billToSetState$.next(id);
  }
  public getBillToSetState = (): Observable<number | null> => {
    return this.billToSetState$.asObservable();
  }
  public setShipToSetState = (id: number | null): void => {
    this.shipToSetState$.next(id);
  }
  public getShipToSetState = (): Observable<number | null> => {
    return this.shipToSetState$.asObservable();
  }
  public setEquipmentDepartment = (facilityId: number | undefined, customerId: number | undefined): void => {
    this.equipmentDepartment$.next({ facilityId: facilityId, customerId: customerId });
  }
  public getEquipmentDepartment = (): Observable<object | null> => {
    return this.equipmentDepartment$.asObservable();
  }
  public setCheckSheetLocation = (modelGroupId: number): void => {
    this.checkSheetLocation$.next(modelGroupId);
  }
  public getCheckSheetLocation = (): Observable<number | null> => {
    return this.checkSheetLocation$.asObservable();
  }
  public setSubmitFunctionHit = (isClicked: boolean): void => {
    this.submitFunctionHit.next(isClicked);
  }
  public setWorkOrderEditMode = (isClicked: boolean): void => {
    this.workOrderEditMode.next(isClicked);
  }
  public setShipToShipment = (carrierId: number | undefined, divisionId: number | undefined, customerOfficeId: number | undefined): void => {
    this.shipToShipment.next({ carrierId: carrierId, divisionId: divisionId, customerOfficeId: customerOfficeId });
  }
  public setLoadContracts = (equipmentId: number, isDefault: boolean, contractId: number | undefined, poNumber: string | undefined): void => {
    this.loadContracts.next({ equipmentId: equipmentId, isDefault: isDefault, contractId: contractId, poNumber: poNumber });
  }
  public setLoadPricingInfo = (workOrderId: number | undefined, workOrderModelGroupId: number | undefined, workOrderPricingTable: string | undefined, workOrderCustomerOfficeCode: string | undefined): void => {
    this.loadpricingInfo.next({ workOrderId: workOrderId, workOrderModelGroupId: workOrderModelGroupId, workOrderPricingTable: workOrderPricingTable, workOrderCustomerOfficeCode: workOrderCustomerOfficeCode });
  }
  public setDisabledRemoveButtons = (isDisabled: boolean): void => {
    this.disabledRemoveButtons.next(isDisabled);
  }


}
